const Persistance = {
  state: {
    unit: {},
    lesson: {},
    challenge: {},
    subject: {}
  },
  mutations: {
    setUnit(state, payload) {
      state.unit = payload;
    },
    setLesson(state, payload) {
      state.lesson = payload;
    },
    setChallenge(state, payload) {
      state.challenge = payload;
    },
    setSubject(state, payload) {
      state.subject = payload;
    }
  },
  getters: {
    unit: state => state.unit,
    lesson: state => state.lesson,
    challenge: state => state.challenge,
    subject: state => state.subject
  }
};

export default Persistance;
